<template>
	<div class="barcodePage">
		<div class="actions mb-2 mt-2 hidden-print">
			<div class="pull-left">
				<b-button @click="goBackToFrom" variant="outline-dark">
					<i class="fa fa-chevron-left mr-1"/>{{ $t('back') }}
				</b-button>
			</div>
			<div class="pull-right">
				<b-button
					variant="outline-dark"
					@click="print"
					class="mr-2"
				>
					<i class="fa fa-print mr-1"/>
					{{ $t('Печать') }}
				</b-button>
			</div>
			<div class="clearfix"/>
		</div>
		<div class="doc-body">
			<b-card>
				<b-row>
					<b-col cols="5">
						<b-form-group
							label-size="sm"
							label-cols="1"
							label="Тип :"
							class="mb-2" size="sm">
							<b-input-group class="shodowed-group">
								<b-form-select
									:options="action"
									v-model="activeAction"
									size="sm"
									id="categoryFilter">
									<template slot="first">
										<option :value="null" disabled>
											-- {{ $t('Типы') }} --
										</option>
									</template>
								</b-form-select>
								<b-input-group-append>
									<b-input-group-addon>
										<b-button type="button"
												  size="sm"
												  variant="outline-default"
												  @click="activeAction = null"
												  v-b-tooltip.hover :title="$t('contragent.clear')">
											<i class="fa fa-close"></i>
										</b-button>
									</b-input-group-addon>
								</b-input-group-append>
							</b-input-group>
						</b-form-group>
					</b-col>
					<b-col></b-col>
					<b-col v-if="activeAction !== 'Barcode' && activeAction" cols="5">
						<b-form-group
							label-size="sm"
							label-cols="3"
							:label="$t('sidebar.organization-structure.departments')+ ':'"
							class="mb-2" size="sm">
							<b-input-group class="shodowed-group">
								<b-form-select
									:options="departments"
									v-model="departmentId"
									text-field="name"
									size="sm"
									id="categoryFilter">
									<template slot="first">
										<option :value="null" disabled>
											-- {{ $t('sidebar.organization-structure.departments') }} --
										</option>
									</template>
								</b-form-select>
								<b-input-group-append>
									<b-input-group-addon>
										<b-button type="button"
												  size="sm"
												  variant="outline-default"
												  @click="departmentId = null"
												  v-b-tooltip.hover :title="$t('contragent.clear')">
											<i class="fa fa-close"></i>
										</b-button>
									</b-input-group-addon>
								</b-input-group-append>
							</b-input-group>
						</b-form-group>
					</b-col>
				</b-row>
				<div v-if="activeAction">
					<b-row class="mt-3">
						<b-col>
							<b-form-group
								label-size="sm"
								label-cols="4"
								:label="$t('incomes.create.counteragent')+ ':'"
								class="mb-2" size="sm">
								<b-input-group class="shodowed-group">
									<b-form-select
										:options="action"
										v-model="activeAction"
										size="sm"
										id="categoryFilter">
										<template slot="first">
											<option :value="null" disabled>
												-- {{ $t('contragent.search-category') }} --
											</option>
										</template>
									</b-form-select>
									<b-input-group-append>
										<b-input-group-addon>
											<b-button type="button"
													  size="sm"
													  variant="outline-default"
													  @click="activeAction = null"
													  v-b-tooltip.hover :title="$t('contragent.clear')">
												<i class="fa fa-close"></i>
											</b-button>
										</b-input-group-addon>
									</b-input-group-append>
								</b-input-group>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group
								label-size="sm"
								label-cols="4"
								:label="$t('incomes.create.counteragent')+ ':'"
								class="mb-2" size="sm">
								<b-input-group class="shodowed-group">
									<b-form-select
										:options="action"
										v-model="activeAction"
										size="sm"
										id="categoryFilter">
										<template slot="first">
											<option :value="null" disabled>
												-- {{ $t('contragent.search-category') }} --
											</option>
										</template>
									</b-form-select>
									<b-input-group-append>
										<b-input-group-addon>
											<b-button type="button"
													  size="sm"
													  variant="outline-default"
													  @click="activeAction = null"
													  v-b-tooltip.hover :title="$t('contragent.clear')">
												<i class="fa fa-close"></i>
											</b-button>
										</b-input-group-addon>
									</b-input-group-append>
								</b-input-group>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group
								label-size="sm"
								label-cols="4"
								:label="$t('incomes.create.counteragent')+ ':'"
								class="mb-2" size="sm">
								<b-input-group class="shodowed-group">
									<b-form-select
										:options="action"
										v-model="activeAction"
										size="sm"
										id="categoryFilter">
										<template slot="first">
											<option :value="null" disabled>
												-- {{ $t('contragent.search-category') }} --
											</option>
										</template>
									</b-form-select>
									<b-input-group-append>
										<b-input-group-addon>
											<b-button type="button"
													  size="sm"
													  variant="outline-default"
													  @click="activeAction = null"
													  v-b-tooltip.hover :title="$t('contragent.clear')">
												<i class="fa fa-close"></i>
											</b-button>
										</b-input-group-addon>
									</b-input-group-append>
								</b-input-group>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group
								label-size="sm"
								label-cols="3"
								label="Search :"
								class="mb-2" size="sm">
								<b-input-group class="shodowed-group" size="sm">
									<b-input placeholder="search"/>
									<b-input-group-append>
										<b-input-group-addon>
											<b-button type="button"
													  size="sm"
													  variant="outline-default"
													  @click="activeAction = null"
													  v-b-tooltip.hover :title="$t('contragent.clear')">
												<i class="fa fa-close"></i>
											</b-button>
										</b-input-group-addon>
									</b-input-group-append>
								</b-input-group>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row class="mt-3">
						<b-col>
							<b-table
								:items="filterItems.items"
								:fields="fields"
								hover
								striped
								responsive
								show-empty
								:per-page="0"
							>
								<template slot="index" slot-scope="data">
									{{ paginate(data.index, filterPagination.page, filterPagination.limit) }}
								</template>
								<template slot="multiBarcode" slot-scope="data">
									<h6>
										<b-badge v-for="barcode in data.item.multiBarcode" class="ml-2">{{
												barcode
											}}
										</b-badge>
									</h6>
								</template>
								<template slot="action" slot-scope="data">
									<b-link class="text-success" @click="addBarcodeItems(data.index, data.item)">
										<i style="font-size: 15px" class="fa fa-check"/>
									</b-link>
								</template>
							</b-table>
							<nav>
								<b-pagination
									:total-rows="filterItems.total"
									:per-page="filterPagination.limit"
									v-model="filterPagination.page"
									aria-controls="table"/>
							</nav>
						</b-col>
					</b-row>
					<b-row class="mt-3">
						<b-col>
							<b-table
								:items="items"
								:fields="fields"
								hover
								striped
								responsive
								show-empty
								:per-page="0"
							>
								<template slot="index" slot-scope="data">
									{{ data.index + 1 }}
								</template>
								<template slot="multiBarcode" slot-scope="data">
									<b-select
										size="sm"
										:options="data.item.multiBarcode"
										:value="data.item.multiBarcode[0]"/>
								</template>
								<template slot="action" slot-scope="data">
									<b-link class="text-danger" @click="deleteItem(data.index)">
										<i style="font-size: 15px" class="fa fa-trash"/>
									</b-link>
								</template>
							</b-table>
						</b-col>
					</b-row>
				</div>
			</b-card>
		</div>
	</div>
</template>

<script>
import UsersService from "../../../../services/users.sevice";

export default {
	name: "BarcodeGeneratePage",
	data() {
		return {
			activeAction: null,
			action: [
				'Barcode',
				'Barcode and price',
				'Price'
			],
			fields: [
				{key: 'index', label: '№', class: 'text-center'},
				{key: 'itemName', label: this.$t('goods.name'), sortable: true},
				{key: 'barcode', label: this.$t('goods.special-barcode'), class: 'text-center'},
				{key: 'multiBarcode', label: this.$t('goods.barcode'), class: 'text-center'},
				{key: 'action', label: this.$t('goods.actions'), class: 'text-center'}
			],
			filterItems: {
				items: [
					{
						itemName: 'Danzka Vodka Twinp. 40% 4x1L',
						barcode: 'H-123423',
						multiBarcode: ['12312312312', '12312312312']
					},
					{
						itemName: 'OSBORNE SOLAZ RED 0.75 L',
						barcode: 'D-123423',
						multiBarcode: ['12312312312', '12312312312']
					},
					{itemName: 'Tenjaku 40% 0.7L', barcode: 'B-123423', multiBarcode: ['12312312312', '12312312312']}
				],
				total: 3
			},
			filterPagination: {
				page: 1,
				limit: 20
			},
			barcodeItems: [],
			barcodeEndPrice: [],
			priceItems: [],
			departments: [],
			departmentId: null
		}
	},
	computed: {
		items() {
			if (this.activeAction === 'Barcode') {
				return this.barcodeItems
			} else if (this.activeAction === 'Barcode and price') {
				return this.barcodeEndPrice
			} else if (this.activeAction === 'Price') {
				return this.priceItems
			} else {
				return []
			}
		}
	},
	methods: {
		goBackToFrom() {
			this.$router.back();
		},
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		addBarcodeItems(index, item) {
			if (this.activeAction === 'Barcode') {
				this.barcodeItems.forEach(tmp => {
					if (tmp.itemId !== item.itemId) {
						this.barcodeItems.unshift(item)
					}
				})
			} else if (this.activeAction === 'Barcode and price') {
				this.barcodeEndPrice.unshift(item)
			} else if (this.activeAction === 'Price') {
				this.priceItems.unshift(item)
			} else {
			}
		},
		deleteItem(index) {
		}
	},
	created() {
		UsersService.getPermittedDepartments().then(response => {
			this.departments = response.data.permittedDepartments;
		})
	}
}
</script>

<style scoped>
.barcodePage {
	margin: 0 20px;
}
</style>
